import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TableCell } from './../../../../../themes/table';

const styles = theme => ({
  root: {
    borderBottom: `3px solid ${ theme.palette.grey[50] }`,
    paddingRight: theme.spacing.unit * 1.5,
    paddingLeft: theme.spacing.unit * 1.5,
    paddingTop: 0,
    paddingBottom: 0,
    "& > *": {
      "&:not(:last-child)": {
        marginRight: theme.spacing.unit / 2
      }
    }
  }
});

const Cell = ({ children, ...rest}) => {

  const { classes }  = rest;

  return (
    <TableCell className={ classes.root } {...rest}>
      { children }
    </TableCell>
  );

}

Cell.propTypes = {
  children: PropTypes.node
};

export default withStyles(styles)(Cell);
